import { configureStore } from '@reduxjs/toolkit';
import { journeySlice } from '../../../lib/client/features/journeyBuilder/journeySlice';
import { simpleConfigurationPageSlice } from './features/simpleConfigurationPage/simpleConfigurationPageSlice';

export const store = configureStore({
    reducer: {
        journey: journeySlice.reducer,
        simpleConfigurationPage: simpleConfigurationPageSlice.reducer,
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
